export default function(value, {other, isField = false, strict = true} = {}, validator) {
    let target = other

    if( isField ) {
        target = validator.form().get(other)
    }

    if( ! strict) {
        return value == target
    }

    return value === target
}
